import { IPdpaUpdate, IOnformParams } from "@interfaces";
import axiosClient from "./axiosClient";

export const pdpaApi = {
    getPdpasToAccept: () => {
        const url = "/clientpdpas/getPdpasToAccept";
        return axiosClient.get(url);
    },
    postPdpaToAccept: (params: IPdpaUpdate) => {
        const url = "/clientpdpas/postPdpaToAccept";
        return axiosClient.post(url, params);
    },
    getOnformListByClientId: (params: IOnformParams) => {
        const url = "/clientpdpas/getOnformListByClientId";
        return axiosClient.get(url, { params });
    },
    getDetail: (id: string) => {
        const url = `/clientpdpas/${id}`;
        return axiosClient.get(url);
    },
    getPurpose: (id: string) => {
        const url = `/clientpdpas/${id}/`;
        return axiosClient.get(url);
    },
};
